import { useState, useCallback } from "react";
import { debounce } from "@mui/material";
import { useClients } from "./useClients";
import { DEBOUNCE_INPUT } from "../../../constants";

const useClientOptions = (location_id = null) => {
  const [term, setTerm] = useState("");
  const { result, loading } = useClients(term, location_id);

  return {
    options: result,
    search: useCallback(debounce(setTerm, DEBOUNCE_INPUT), []),
    loading: loading,
  };
};

export { useClientOptions };
